/*@ngInject*/
const UserProfileDropdownController = function ($rootScope, headerConstant) {

    this.onClick = function (menuItem) {
        $rootScope.$broadcast(headerConstant.event.CLOSE_USER_PROFILE_DROPDOWN);
        menuItem.action();
    };
};

angular.module('gw-um-header')
    .controller('userProfileDropdownController', UserProfileDropdownController);
